(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Cart Login Gate
    const cartForm = document.getElementById('CartForm');
    const cartCheckoutBtn = document.getElementById('CartCheckoutBtn');
    const cartLoginOverlay = document.getElementById('CartLoginGateOverlay');
    const cartLoginClose = document.getElementById('CartLoginGateClose');
    const isCartLoggedIn = !!(cartForm && cartForm.getAttribute('data-customer-logged-in'));

    function openCartLoginGate() {
      if (cartLoginOverlay) cartLoginOverlay.classList.add('is-active');
    }
    function closeCartLoginGate() {
      if (cartLoginOverlay) cartLoginOverlay.classList.remove('is-active');
    }
    if (cartLoginClose) cartLoginClose.addEventListener('click', closeCartLoginGate);
    if (cartLoginOverlay) {
      cartLoginOverlay.addEventListener('click', function(e) {
        if (e.target === cartLoginOverlay) closeCartLoginGate();
      });
    }
    if (cartCheckoutBtn && !isCartLoggedIn) {
      cartCheckoutBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openCartLoginGate();
      });
    }

    // Qty buttons
    const qtyMinusBtns = document.querySelectorAll('.qty-minus');
    const qtyPlusBtns = document.querySelectorAll('.qty-plus');

    qtyMinusBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.nextElementSibling;
        const val = parseInt(input.value);
        if (val > 1) {
          input.value = val - 1;
          document.getElementById('CartForm').submit();
        }
      });
    });

    qtyPlusBtns.forEach(btn => {
      btn.addEventListener('click', function() {
        const input = this.previousElementSibling;
        const val = parseInt(input.value);
        input.value = val + 1;
        document.getElementById('CartForm').submit();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    'use strict';

    // Mark page for scoped overflow-x fix
    document.documentElement.classList.add('page--collection');

    // ── IDs of the two swappable regions ──
    var SIDEBAR_ID = 'CollectionFiltersSidebar';
    var MAIN_ID    = 'CollectionMain';
    var FORM_ID    = 'CollectionFiltersForm';

    // Debounce helper (for price range inputs)
    function debounce(fn, delay) {
      var t;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, delay);
      };
    }

    // ── Show / hide loading state on product grid ──
    function setLoading(isLoading) {
      var main = document.getElementById(MAIN_ID);
      if (!main) return;
      if (isLoading) {
        main.style.opacity = '0.45';
        main.style.pointerEvents = 'none';
        main.style.transition = 'opacity 0.2s';
      } else {
        main.style.opacity = '1';
        main.style.pointerEvents = '';
      }
    }

    // ── Core fetch + swap ──
    function fetchAndUpdate(url) {
      setLoading(true);

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser  = new DOMParser();
          var doc     = parser.parseFromString(html, 'text/html');

          var newSidebar = doc.getElementById(SIDEBAR_ID);
          var newMain    = doc.getElementById(MAIN_ID);

          if (newSidebar) {
            document.getElementById(SIDEBAR_ID).innerHTML = newSidebar.innerHTML;
          }
          if (newMain) {
            document.getElementById(MAIN_ID).innerHTML = newMain.innerHTML;
          }

          // Update URL in address bar without reload
          history.pushState({ url: url }, '', url);

          // Re-attach event listeners to newly injected elements
          attachListeners();
          setLoading(false);

          // Scroll product area into view smoothly if far below
          var mainEl = document.getElementById(MAIN_ID);
          if (mainEl) {
            var rect = mainEl.getBoundingClientRect();
            if (rect.top < 0) {
              mainEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }
        })
        .catch(function () {
          // On network error fall back to normal navigation
          setLoading(false);
          window.location.href = url;
        });
    }

    // ── Build URL from filter form ──
    function getFormUrl() {
      var form = document.getElementById(FORM_ID);
      if (!form) return window.location.href;
      var data = new FormData(form);
      var params = new URLSearchParams();
      data.forEach(function (value, key) {
        if (value !== '') params.append(key, value);
      });
      // Preserve sort_by from the SortBy select even if outside form data
      var sortEl = document.getElementById('SortBy');
      if (sortEl && !params.has('sort_by')) {
        params.set('sort_by', sortEl.value);
      }
      return window.location.pathname + '?' + params.toString();
    }

    // ── Attach listeners ──
    function attachListeners() {
      var sidebar = document.getElementById(SIDEBAR_ID);
      var main    = document.getElementById(MAIN_ID);
      var form    = document.getElementById(FORM_ID);
      if (!sidebar || !main || !form) return;

      // Intercept form submit (noscript fallback)
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        fetchAndUpdate(getFormUrl());
      });

      // Apply Filters button — validate price range first, then fire fetch
      var applyBtn = document.getElementById('ApplyFiltersBtn');
      if (applyBtn) {
        applyBtn.addEventListener('click', function () {
          var form    = document.getElementById(FORM_ID);
          var warning = document.getElementById('PriceRangeWarning');

          // Find min / max price inputs (type=number inside the sidebar)
          var minInput = form ? form.querySelector('input[type="number"][name*="filter"][id*="min"], input[type="number"]:first-of-type') : null;
          var maxInput = form ? form.querySelector('input[type="number"][name*="filter"][id*="max"], input[type="number"]:last-of-type') : null;

          // Look up by id prefix set in the liquid (id="Filter-filter.p.m...") 
          // Fallback: grab the two number inputs in order
          var numInputs = form ? Array.from(form.querySelectorAll('input[type="number"]')) : [];
          if (numInputs.length >= 2) {
            minInput = numInputs[0];
            maxInput = numInputs[1];
          }

          var minVal = minInput && minInput.value !== '' ? parseFloat(minInput.value) : null;
          var maxVal = maxInput && maxInput.value !== '' ? parseFloat(maxInput.value) : null;

          if (minVal !== null && maxVal !== null && minVal >= maxVal) {
            // Show warning
            if (warning) {
              warning.classList.add('price-range-warning--visible');
              minInput.classList.add('price-input--error');
              maxInput.classList.add('price-input--error');
              minInput.focus();
            }
            return; // Block filter apply
          }

          // Clear warning if valid
          if (warning) {
            warning.classList.remove('price-range-warning--visible');
            if (minInput) minInput.classList.remove('price-input--error');
            if (maxInput) maxInput.classList.remove('price-input--error');
          }

          fetchAndUpdate(getFormUrl());
        });
      }

      // Sort selector
      var sortEl = document.getElementById('SortBy');
      if (sortEl) {
        sortEl.addEventListener('change', function () {
          fetchAndUpdate(getFormUrl());
        });
      }

      // Active-filter remove tags (href-based) — inside both sidebar & main
      [sidebar, main].forEach(function (region) {
        region.querySelectorAll('a.active-filter-tag, a.filter-clear-all').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            fetchAndUpdate(link.href);
          });
        });
      });

      // Pagination links
      main.querySelectorAll('.pagination a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          fetchAndUpdate(link.href);
        });
      });
    }

    // ── Handle browser back/forward ──
    window.addEventListener('popstate', function (e) {
      var url = (e.state && e.state.url) ? e.state.url : window.location.href;
      fetchAndUpdate(url);
    });

    // ── Init ──
    document.addEventListener('DOMContentLoaded', function () {
      // Save initial state so popstate works on first back-navigation
      history.replaceState({ url: window.location.href }, '', window.location.href);
      attachListeners();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us"]) return;
  try {
    
(function () {
  var form = document.getElementById('ContactForm');
  if (!form) return;

  form.addEventListener('submit', function () {
    var name    = getVal('contact[name]');
    var email   = getVal('contact[email]');
    var phone   = getVal('contact[phone]');
    var message = getVal('contact[body]');

    if (!email) return;

    var subject = 'Contact Us Enquiry from ' + (name || email);

    var lines = [
      '========================================',
      '   CONTACT US — PRADIP FABRICS',
      '========================================',
      '',
      'SENDER DETAILS',
      '---------------',
      'Full Name    : ' + (name  || 'N/A'),
      'Email        : ' + email,
      'Phone Number : ' + (phone || 'N/A'),
      '',
      'MESSAGE',
      '--------',
      (message || 'N/A'),
      '',
      '========================================',
      'Source: pradipfabrics.com/pages/contact-us',
      '========================================'
    ];

    var emailBody = lines.join('\r\n');

    var mailto = 'mailto:support@pradipfabrics.com'
               + '?subject=' + encodeURIComponent(subject)
               + '&body='    + encodeURIComponent(emailBody);

    setTimeout(function () {
      window.location.href = mailto;
    }, 100);
  });

  function getVal(fieldName) {
    var el = form.querySelector('[name="' + fieldName + '"]');
    return el ? el.value.trim() : '';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coupon-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popup = document.querySelector('.coupon-popup-overlay');
    if (!popup) return;

    const couponCode = popup.getAttribute('data-coupon-code');
    const delay = parseInt(popup.getAttribute('data-delay-ms'), 10) || 3000;
    const storageKey = `coupon-popup-dismissed-${couponCode}`;

    // If already dismissed, do not display
    if (localStorage.getItem(storageKey)) {
      return;
    }

    // Show after the configured delay
    setTimeout(() => {
      popup.style.display = 'flex';
      // Trigger browser reflow to run transition
      popup.offsetHeight;
      popup.classList.add('active');
    }, delay);

    // Close button logic
    const closeBtn = popup.querySelector('.coupon-popup-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        popup.classList.remove('active');
        localStorage.setItem(storageKey, 'true');
        setTimeout(() => {
          popup.style.display = 'none';
        }, 400); // Wait for transition animation to end
      });
    }

    // Modal backdrop click close logic
    const backdrop = popup.querySelector('.coupon-popup-backdrop');
    if (backdrop) {
      backdrop.addEventListener('click', () => {
        popup.classList.remove('active');
        localStorage.setItem(storageKey, 'true');
        setTimeout(() => {
          popup.style.display = 'none';
        }, 400);
      });
    }

    // Copy to clipboard logic
    const copyBtn = popup.querySelector('.coupon-popup-copy-btn');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        navigator.clipboard.writeText(couponCode).then(() => {
          const btnText = copyBtn.querySelector('.popup-copy-text');
          if (btnText) {
            const originalText = btnText.textContent;
            btnText.textContent = 'Copied!';
            copyBtn.classList.add('copied');
            setTimeout(() => {
              btnText.textContent = originalText;
              copyBtn.classList.remove('copied');
            }, 2000);
          }
          
          // Toast fallback check
          if (typeof showToast === 'function') {
            showToast(`✓ Coupon code "${couponCode}" copied to clipboard!`);
          } else {
            let toast = document.getElementById('coupon-toast');
            if (!toast) {
              toast = document.createElement('div');
              toast.id = 'coupon-toast';
              toast.style.cssText = 'position:fixed;bottom:20px;right:20px;background:#800020;color:#fff;padding:12px 24px;border-radius:4px;z-index:99999;font-size:0.9rem;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s;opacity:0;pointer-events:none;';
              document.body.appendChild(toast);
            }
            toast.textContent = `✓ Coupon "${couponCode}" copied!`;
            toast.style.opacity = '1';
            setTimeout(() => {
              toast.style.opacity = '0';
            }, 2500);
          }
        }).catch(err => {
          console.error('Failed to copy code: ', err);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coupons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const copyBtns = document.querySelectorAll('.coupon-section-copy-btn');
    copyBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const card = this.closest('.coupon-card');
        const code = card ? card.getAttribute('data-coupon-code') : '';
        if (code) {
          navigator.clipboard.writeText(code).then(() => {
            const btnText = this.querySelector('.btn-text');
            if (btnText) {
              const originalText = btnText.textContent;
              btnText.textContent = 'Copied!';
              this.classList.add('copied');
              setTimeout(() => {
                btnText.textContent = originalText;
                this.classList.remove('copied');
              }, 2000);
            }
            
            // Check if there is a custom toast function in the theme, otherwise fallback to alert/console
            if (typeof showToast === 'function') {
              showToast(`✓ Coupon code "${code}" copied to clipboard!`);
            } else {
              // Custom mini-toast implementation for this section if not globally available
              let toast = document.getElementById('coupon-toast');
              if (!toast) {
                toast = document.createElement('div');
                toast.id = 'coupon-toast';
                toast.style.cssText = 'position:fixed;bottom:20px;right:20px;background:#800020;color:#fff;padding:12px 24px;border-radius:4px;z-index:9999;font-size:0.9rem;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s;opacity:0;pointer-events:none;';
                document.body.appendChild(toast);
              }
              toast.textContent = `✓ Coupon "${code}" copied!`;
              toast.style.opacity = '1';
              setTimeout(() => {
                toast.style.opacity = '0';
              }, 2500);
            }
          }).catch(err => {
            console.error('Failed to copy text: ', err);
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener("DOMContentLoaded", function () {
      document.querySelectorAll(".lookbook-gallery").forEach(function (section) {
        initGalleryCarousel(section);
      });
    });

    document.addEventListener("shopify:section:load", function (e) {
      var section = e.target.querySelector(".lookbook-gallery");
      if (section) initGalleryCarousel(section);
    });

    function initGalleryCarousel(section) {
      const track = section.querySelector(".gallery-carousel-track");
      if (!track) return;

      const rawSlides = Array.from(track.querySelectorAll(".gallery-carousel-slide"));
      if (rawSlides.length === 0) return;

      let initialized = false;

      function setupCarousel() {
        if (initialized) return;
        initialized = true;

        // Re-query valid remaining slides
        const validSlides = Array.from(track.querySelectorAll(".gallery-carousel-slide"));

        // If placeholders exist alongside real images, remove placeholders
        const realSlides = validSlides.filter(s => !s.classList.contains("gallery-placeholder-slide"));
        let slides = validSlides;
        if (realSlides.length > 0) {
          validSlides.filter(s => s.classList.contains("gallery-placeholder-slide")).forEach(s => s.remove());
          slides = realSlides;
        }

        if (slides.length === 0) return;

        const prevBtn = section.querySelector(".gallery-control--prev");
        const nextBtn = section.querySelector(".gallery-control--next");
        const dotsContainer = section.querySelector(".gallery-dots");

        let currentIndex = 0;
        let visibleSlides = 3;
        let autoplayTimer = null;
        const autoplayInterval = 5000;

        function updateVisibleSlides() {
          if (window.innerWidth <= 576) {
            visibleSlides = 1;
          } else if (window.innerWidth <= 991) {
            visibleSlides = 2;
          } else {
            visibleSlides = 3;
          }
        }

        updateVisibleSlides();

        function getPagesCount() {
          return Math.ceil(slides.length / visibleSlides);
        }

        function createDots() {
          if (!dotsContainer) return;
          dotsContainer.innerHTML = "";
          const pagesCount = getPagesCount();

          if (pagesCount <= 1) {
            if (prevBtn) prevBtn.style.display = "none";
            if (nextBtn) nextBtn.style.display = "none";
            dotsContainer.style.display = "none";
            return;
          } else {
            if (prevBtn) prevBtn.style.display = "flex";
            if (nextBtn) nextBtn.style.display = "flex";
            dotsContainer.style.display = "flex";
          }

          for (let i = 0; i < pagesCount; i++) {
            const dot = document.createElement("button");
            dot.classList.add("gallery-dot");
            const currentPage = Math.floor(currentIndex / visibleSlides);
            if (i === currentPage) dot.classList.add("active");
            dot.setAttribute("aria-label", `Go to page ${i + 1}`);

            dot.addEventListener("click", () => {
              goToPage(i);
              startAutoplay();
            });
            dotsContainer.appendChild(dot);
          }
        }

        function updateDots() {
          if (!dotsContainer) return;
          const dots = dotsContainer.querySelectorAll(".gallery-dot");
          const currentPage = Math.floor(currentIndex / visibleSlides);
          dots.forEach((dot, index) => {
            if (index === currentPage) {
              dot.classList.add("active");
            } else {
              dot.classList.remove("active");
            }
          });
        }

        function goToPage(pageIndex) {
          let targetIndex = pageIndex * visibleSlides;
          const maxIndex = Math.max(0, slides.length - visibleSlides);
          if (targetIndex > maxIndex) targetIndex = maxIndex;
          if (targetIndex < 0) targetIndex = 0;
          currentIndex = targetIndex;

          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          const slideWidth = slides[0].getBoundingClientRect().width;
          const offset = currentIndex * (slideWidth + gap);
          track.style.transform = `translateX(-${offset}px)`;
          updateDots();
        }

        function nextPage() {
          const maxIndex = Math.max(0, slides.length - visibleSlides);
          if (currentIndex < maxIndex) {
            let nextIndex = currentIndex + visibleSlides;
            if (nextIndex > maxIndex) nextIndex = maxIndex;
            goToPage(Math.floor(nextIndex / visibleSlides));
          } else {
            goToPage(0);
          }
        }

        function prevPage() {
          if (currentIndex > 0) {
            let prevIndex = currentIndex - visibleSlides;
            if (prevIndex < 0) prevIndex = 0;
            goToPage(Math.floor(prevIndex / visibleSlides));
          } else {
            const maxIndex = Math.max(0, slides.length - visibleSlides);
            goToPage(Math.floor(maxIndex / visibleSlides));
          }
        }

        if (prevBtn) prevBtn.onclick = () => { prevPage(); startAutoplay(); };
        if (nextBtn) nextBtn.onclick = () => { nextPage(); startAutoplay(); };

        function startAutoplay() {
          stopAutoplay();
          if (getPagesCount() > 1) {
            autoplayTimer = setInterval(nextPage, autoplayInterval);
          }
        }

        function stopAutoplay() {
          if (autoplayTimer) clearInterval(autoplayTimer);
        }

        createDots();
        startAutoplay();

        section.onmouseenter = stopAutoplay;
        section.onmouseleave = startAutoplay;

        let resizeTimer;
        window.onresize = () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            updateVisibleSlides();
            createDots();
            goToPage(Math.floor(currentIndex / visibleSlides));
          }, 100);
        };
      }

      // Check all images in slides to filter out missing ones before carousel setup
      let pending = rawSlides.length;
      slidesCheck();

      function slidesCheck() {
        if (pending === 0) {
          setupCarousel();
          return;
        }

        rawSlides.forEach(slide => {
          const img = slide.querySelector("img");
          if (!img) {
            slide.remove();
            pending--;
            if (pending === 0) setupCarousel();
            return;
          }

          function checkDone() {
            if (img.naturalWidth === 0 || img.src.includes("no-image")) {
              slide.remove();
            }
            pending--;
            if (pending === 0) setupCarousel();
          }

          if (img.complete) {
            checkDone();
          } else {
            img.addEventListener("load", checkDone, { once: true });
            img.addEventListener("error", () => {
              slide.remove();
              pending--;
              if (pending === 0) setupCarousel();
            }, { once: true });
          }
        });
      }

      // Safety fallback timeout
      setTimeout(setupCarousel, 1200);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // ── 3-dot toggle ──
    var dotsBtn = document.getElementById('dots-btn');
    if (dotsBtn) {
      dotsBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = this.classList.toggle('open');
        this.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function () {
        dotsBtn.classList.remove('open');
        dotsBtn.setAttribute('aria-expanded', 'false');
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          dotsBtn.classList.remove('open');
          dotsBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // ── Sticky shadow enhancement ──
    var header = document.getElementById('site-header');
    if (header) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 10) {
          header.style.boxShadow = '0 4px 24px rgba(0,0,0,0.09)';
        } else {
          header.style.boxShadow = '0 2px 16px rgba(0,0,0,0.03)';
        }
      }, { passive: true });
    }

    // ── Wishlist Badge Count Updater ──
    function updateWishlistBadge() {
      var badge = document.getElementById('WishlistCountBadge');
      if (!badge) return;
      try {
        var items = JSON.parse(localStorage.getItem('wishlist_products')) || [];
        var count = items.length;
        badge.textContent = count;
        if (count > 0) {
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      } catch (e) {
        badge.style.display = 'none';
      }
    }

    updateWishlistBadge();

    // Listen to localStorage changes in the same window (custom events)
    window.addEventListener('wishlist-updated', updateWishlistBadge);
    // Also listen to standard storage event (for changes made in other tabs)
    window.addEventListener('storage', function(e) {
      if (e.key === 'wishlist_products') {
        updateWishlistBadge();
      }
    });

    // ── Mobile Drawer Toggle & Accordion Logic ──
    var mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    var mobileDrawer = document.getElementById('mobile-drawer');
    var mobileDrawerClose = document.getElementById('mobile-drawer-close');
    var mobileDrawerOverlay = document.getElementById('mobile-drawer-overlay');

    function openMobileDrawer() {
      if (!mobileDrawer) return;
      mobileDrawer.setAttribute('aria-hidden', 'false');
      mobileMenuToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    function closeMobileDrawer() {
      if (!mobileDrawer) return;
      mobileDrawer.setAttribute('aria-hidden', 'true');
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    if (mobileMenuToggle) {
      mobileMenuToggle.addEventListener('click', openMobileDrawer);
    }
    if (mobileDrawerClose) {
      mobileDrawerClose.addEventListener('click', closeMobileDrawer);
    }
    if (mobileDrawerOverlay) {
      mobileDrawerOverlay.addEventListener('click', closeMobileDrawer);
    }

    // Handle submenu toggle accordions in mobile drawer
    var submenuTriggers = document.querySelectorAll('.mobile-nav__submenu-trigger');
    submenuTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener("DOMContentLoaded", function () {
      initCarousel();
    });

    // Make it work in the Shopify Customizer / theme editor
    document.addEventListener("shopify:section:load", function (e) {
      if (e.target.querySelector(".hero-carousel")) {
        initCarousel();
      }
    });

    function initCarousel() {
      const carousels = document.querySelectorAll(".hero-carousel");
      
      carousels.forEach(carousel => {
        const slides = carousel.querySelectorAll(".hero-slide");
        if (slides.length <= 1) return;

        const prevBtn = carousel.querySelector(".carousel-control--prev");
        const nextBtn = carousel.querySelector(".carousel-control--next");
        const dots = carousel.querySelectorAll(".carousel-dot");
        
        let currentIndex = 0;
        let timer = null;
        const intervalTime = 6000; // 6 seconds

        function showSlide(index) {
          slides[currentIndex].classList.remove("active");
          dots[currentIndex].classList.remove("active");
          
          currentIndex = (index + slides.length) % slides.length;
          
          slides[currentIndex].classList.add("active");
          dots[currentIndex].classList.add("active");
        }

        function nextSlide() {
          showSlide(currentIndex + 1);
        }

        function prevSlide() {
          showSlide(currentIndex - 1);
        }

        function startTimer() {
          stopTimer();
          timer = setInterval(nextSlide, intervalTime);
        }

        function stopTimer() {
          if (timer) clearInterval(timer);
        }

        // Event Listeners
        if (prevBtn) {
          prevBtn.addEventListener("click", () => {
            prevSlide();
            startTimer();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener("click", () => {
            nextSlide();
            startTimer();
          });
        }

        dots.forEach(dot => {
          dot.addEventListener("click", (e) => {
            const index = parseInt(e.target.getAttribute("data-index"));
            showSlide(index);
            startTimer();
          });
        });

        // Pause autoplay on mouse hover
        carousel.addEventListener("mouseenter", stopTimer);
        carousel.addEventListener("mouseleave", startTimer);

        // Start initial timer
        startTimer();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener("DOMContentLoaded", function () {
      initJournalCarousel();
    });

    document.addEventListener("shopify:section:load", function (e) {
      if (e.target.querySelector(".journal")) {
        initJournalCarousel();
      }
    });

    function initJournalCarousel() {
      const sections = document.querySelectorAll(".journal");
      sections.forEach(section => {
        const track = section.querySelector(".journal-carousel-track");
        if (!track) return;
        const slides = track.querySelectorAll(".journal-carousel-slide");
        if (slides.length === 0) return;

        const prevBtn = section.querySelector(".journal-control--prev");
        const nextBtn = section.querySelector(".journal-control--next");
        const dotsContainer = section.querySelector(".journal-dots");

        let currentIndex = 0;
        let visibleSlides = 3;
        let autoplayTimer = null;
        const autoplayInterval = 5000;

        function updateVisibleSlides() {
          if (window.innerWidth <= 768) {
            visibleSlides = 1;
          } else if (window.innerWidth <= 991) {
            visibleSlides = 2;
          } else {
            visibleSlides = 3;
          }
        }

        updateVisibleSlides();

        function getPagesCount() {
          return Math.ceil(slides.length / visibleSlides);
        }

        function createDots() {
          if (!dotsContainer) return;
          dotsContainer.innerHTML = "";
          const pagesCount = getPagesCount();
          
          for (let i = 0; i < pagesCount; i++) {
            const dot = document.createElement("button");
            dot.classList.add("journal-dot");
            const currentPage = Math.floor(currentIndex / visibleSlides);
            if (i === currentPage) dot.classList.add("active");
            dot.setAttribute("aria-label", `Go to page ${i + 1}`);
            
            dot.addEventListener("click", () => {
              goToPage(i);
              startAutoplay();
            });
            dotsContainer.appendChild(dot);
          }
        }

        function updateDots() {
          if (!dotsContainer) return;
          const dots = dotsContainer.querySelectorAll(".journal-dot");
          const currentPage = Math.floor(currentIndex / visibleSlides);
          dots.forEach((dot, index) => {
            if (index === currentPage) {
              dot.classList.add("active");
            } else {
              dot.classList.remove("active");
            }
          });
        }

        function goToPage(pageIndex) {
          const pagesCount = getPagesCount();
          let targetIndex = pageIndex * visibleSlides;
          
          const maxIndex = slides.length - visibleSlides;
          if (targetIndex > maxIndex) {
            targetIndex = maxIndex;
          }
          if (targetIndex < 0) targetIndex = 0;

          currentIndex = targetIndex;

          const gap = parseFloat(getComputedStyle(track).gap) || 0;
          const slideWidth = slides[0].getBoundingClientRect().width;
          const offset = currentIndex * (slideWidth + gap);

          track.style.transform = `translateX(-${offset}px)`;
          updateDots();
        }

        function nextPage() {
          const maxIndex = slides.length - visibleSlides;
          if (currentIndex < maxIndex) {
            let nextIndex = currentIndex + visibleSlides;
            if (nextIndex > maxIndex) nextIndex = maxIndex;
            goToPage(Math.floor(nextIndex / visibleSlides));
          } else {
            goToPage(0);
          }
        }

        function prevPage() {
          if (currentIndex > 0) {
            let prevIndex = currentIndex - visibleSlides;
            if (prevIndex < 0) prevIndex = 0;
            goToPage(Math.floor(prevIndex / visibleSlides));
          } else {
            const maxIndex = slides.length - visibleSlides;
            goToPage(Math.floor(maxIndex / visibleSlides));
          }
        }

        if (prevBtn) {
          prevBtn.addEventListener("click", () => {
            prevPage();
            startAutoplay();
          });
        }

        if (nextBtn) {
          nextBtn.addEventListener("click", () => {
            nextPage();
            startAutoplay();
          });
        }

        function startAutoplay() {
          stopAutoplay();
          autoplayTimer = setInterval(nextPage, autoplayInterval);
        }

        function stopAutoplay() {
          if (autoplayTimer) {
            clearInterval(autoplayTimer);
          }
        }

        createDots();
        startAutoplay();

        section.addEventListener("mouseenter", stopAutoplay);
        section.addEventListener("mouseleave", startAutoplay);

        let resizeTimer;
        window.addEventListener("resize", () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            updateVisibleSlides();
            createDots();
            goToPage(Math.floor(currentIndex / visibleSlides));
          }, 100);
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const copyBtns = document.querySelectorAll('.coupon-mini-copy-btn');
    copyBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const card = this.closest('.premium-coupon-card');
        const code = card ? card.getAttribute('data-coupon-code') : '';
        if (code) {
          navigator.clipboard.writeText(code).then(() => {
            const btnText = this.querySelector('.copy-btn-text');
            if (btnText) {
              const originalText = btnText.textContent;
              btnText.textContent = 'Copied!';
              this.classList.add('copied');
              setTimeout(() => {
                btnText.textContent = originalText;
                this.classList.remove('copied');
              }, 2000);
            }
            
            // Custom mini-toast implementation for this page
            let toast = document.getElementById('coupon-toast');
            if (!toast) {
              toast = document.createElement('div');
              toast.id = 'coupon-toast';
              toast.style.cssText = 'position:fixed;bottom:20px;right:20px;background:#800020;color:#fff;padding:12px 24px;border-radius:4px;z-index:9999;font-size:0.9rem;box-shadow:0 4px 12px rgba(0,0,0,0.15);transition:opacity 0.3s;opacity:0;pointer-events:none;';
              document.body.appendChild(toast);
            }
            toast.textContent = `✓ Coupon "${code}" copied!`;
            toast.style.opacity = '1';
            setTimeout(() => {
              toast.style.opacity = '0';
            }, 2500);
          }).catch(err => {
            console.error('Failed to copy text: ', err);
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["saree-collections"] && !Shopify.designMode) return;
  try {
    
(function () {
  var wrapper = document.querySelector('[data-sc-section]');
  if (!wrapper) return;

  var track        = wrapper.querySelector('.sc-track');
  var dotsBar      = wrapper.querySelector('.sc-dots');
  var btnPrev      = wrapper.querySelector('.sc-arrow-prev');
  var btnNext      = wrapper.querySelector('.sc-arrow-next');
  var allSlides    = Array.from(wrapper.querySelectorAll('.sc-slide'));
  var liveSlides   = [];
  var currentIndex = 0;
  var perView      = 3;
  var totalProbed  = 0;

  function getPerView() {
    if (window.innerWidth < 600) return 1;
    if (window.innerWidth < 900) return 2;
    return 3;
  }

  function buildCarousel() {
    if (!liveSlides.length) return;
    perView = getPerView();

    // Reveal arrows and dots only if more slides than perView
    if (liveSlides.length > perView) {
      btnPrev.style.display = '';
      btnNext.style.display = '';
      dotsBar.style.display = '';
    }

    // Build dots
    var totalDots = Math.ceil(liveSlides.length / perView);
    dotsBar.innerHTML = '';
    for (var d = 0; d < totalDots; d++) {
      var dot = document.createElement('button');
      dot.className = 'sc-dot' + (d === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Slide group ' + (d + 1));
      dot.dataset.index = d;
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index) * perView);
      });
      dotsBar.appendChild(dot);
    }

    goTo(0);
  }

  function goTo(idx) {
    perView = getPerView();
    var max = Math.max(0, liveSlides.length - perView);
    currentIndex = Math.min(Math.max(idx, 0), max);

    // Slide the track
    var slideWidth = liveSlides[0].getBoundingClientRect().width;
    track.style.transform = 'translateX(-' + (currentIndex * (slideWidth + 24)) + 'px)';

    // Update dots
    var activeDot = Math.floor(currentIndex / perView);
    Array.from(dotsBar.querySelectorAll('.sc-dot')).forEach(function (d, i) {
      d.classList.toggle('active', i === activeDot);
    });

    // Update arrow states
    btnPrev.disabled = currentIndex <= 0;
    btnNext.disabled = currentIndex >= max;
  }

  btnPrev.addEventListener('click', function () { goTo(currentIndex - perView); });
  btnNext.addEventListener('click', function () { goTo(currentIndex + perView); });

  // Touch/swipe support
  var touchStartX = 0;
  track.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  track.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) goTo(diff > 0 ? currentIndex + perView : currentIndex - perView);
  });

  window.addEventListener('resize', function () { goTo(currentIndex); });

  // Image probing — show slide when real image loads
  function probeSlide(slide, srcList, idx) {
    if (idx >= srcList.length) {
      // All failed — remove from DOM and skip
      slide.parentNode && slide.parentNode.removeChild(slide);
      onProbeComplete();
      return;
    }
    var src = srcList[idx];
    if (!src) { probeSlide(slide, srcList, idx + 1); return; }

    var img = new Image();
    img.onload = function () {
      if (img.naturalWidth > 1) {
        var imgEl = slide.querySelector('.sc-card-img');
        if (imgEl) imgEl.src = src;
        slide.style.display = '';
        slide.style.animation = 'scSlideIn 0.4s ease both';
        liveSlides.push(slide);
        onProbeComplete();
      } else {
        probeSlide(slide, srcList, idx + 1);
      }
    };
    img.onerror = function () { probeSlide(slide, srcList, idx + 1); };
    img.src = src;
  }

  function onProbeComplete() {
    totalProbed++;
    if (totalProbed === allSlides.length) {
      // All probing done — sort liveSlides by DOM order and build carousel
      liveSlides.sort(function (a, b) {
        return a.compareDocumentPosition(b) & 4 ? -1 : 1;
      });
      buildCarousel();
    }
  }

  allSlides.forEach(function (slide) {
    var jpg = slide.dataset.jpg || '';
    var png = slide.dataset.png || '';
    probeSlide(slide, [jpg, png], 0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Clear search button behavior
    const clearBtn = document.getElementById('SearchClearBtn');
    const searchInput = document.getElementById('SearchInput');
    
    if (clearBtn && searchInput) {
      clearBtn.addEventListener('click', () => {
        searchInput.value = '';
        searchInput.focus();
        clearBtn.style.display = 'none';
      });
      
      searchInput.addEventListener('input', () => {
        if (searchInput.value.trim() !== '') {
          clearBtn.style.display = 'flex';
        } else {
          clearBtn.style.display = 'none';
        }
      });
    }

    // Client-side filtering tabs
    const tabs = document.querySelectorAll('.tab-btn');
    const items = document.querySelectorAll('.grid-item-card');
    const fallback = document.getElementById('EmptyCategoryFallback');
    
    if (tabs.length && items.length) {
      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          // Remove active class from all tabs
          tabs.forEach(t => t.classList.remove('active'));
          // Add active class to clicked tab
          tab.classList.add('active');
          
          const filterValue = tab.getAttribute('data-filter');
          let visibleCount = 0;
          
          items.forEach(item => {
            const itemType = item.getAttribute('data-type');
            if (filterValue === 'all' || itemType === filterValue) {
              item.style.display = 'block';
              visibleCount++;
            } else {
              item.style.display = 'none';
            }
          });
          
          // Toggle fallback if no items are visible in the category
          if (visibleCount === 0) {
            if (fallback) fallback.style.display = 'flex';
          } else {
            if (fallback) fallback.style.display = 'none';
          }
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-inquiry"]) return;
  try {
    
(function () {
  var form = document.getElementById('WholesaleInquiryForm');
  if (!form) return;

  form.addEventListener('submit', function () {
    // Collect all field values using exact name attributes
    var name     = getVal('contact[first_name]');
    var company  = getVal('contact[Company]');
    var email    = getVal('contact[email]');
    var phone    = getVal('contact[phone]');
    var volume   = getVal('contact[Order Volume]');
    var interest = getVal('contact[Collection Interest]');
    var location = getVal('contact[Location]');
    var message  = getVal('contact[body]');

    if (!email || !name) return;

    // Professional email subject line
    var subject = 'Wholesale Inquiry from ' + name + (company ? ' (' + company + ')' : '');

    // Properly formatted email body
    var lines = [
      '========================================',
      '   WHOLESALE INQUIRY — PRADIP FABRICS',
      '========================================',
      '',
      'CONTACT DETAILS',
      '----------------',
      'Full Name        : ' + name,
      'Business Name    : ' + (company  || 'N/A'),
      'Email Address    : ' + email,
      'Phone / WhatsApp : ' + (phone    || 'N/A'),
      '',
      'ORDER DETAILS',
      '--------------',
      'Monthly Volume   : ' + (volume   || 'N/A'),
      'Collection       : ' + (interest || 'N/A'),
      'Location         : ' + (location || 'N/A'),
      '',
      'MESSAGE / REQUIREMENTS',
      '-----------------------',
      (message || 'N/A'),
      '',
      '========================================',
      'Source: pradipfabrics.com/pages/wholesale-inquiry',
      '========================================'
    ];

    var emailBody = lines.join('\r\n');

    // Open default mail client with pre-filled content
    var mailto = 'mailto:support@pradipfabrics.com'
                + '?subject=' + encodeURIComponent(subject)
                + '&body='    + encodeURIComponent(emailBody);

    // Open mail client (slight delay so Shopify form submission also fires)
    setTimeout(function () {
      window.location.href = mailto;
    }, 100);
  });

  function getVal(fieldName) {
    var el = form.querySelector('[name="' + fieldName + '"]');
    return el ? el.value.trim() : '';
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const loadingEl = document.getElementById('WishlistLoading');
    const emptyEl = document.getElementById('WishlistEmpty');
    const gridEl = document.getElementById('WishlistGrid');
    const toast = document.getElementById('WishlistToast');
    const toastMsg = document.getElementById('WishlistToastMessage');

    function showToast(message) {
      toastMsg.textContent = message;
      toast.classList.add('show');
      setTimeout(() => {
        toast.classList.remove('show');
      }, 3000);
    }

    function loadWishlist() {
      let items = [];
      try {
        items = JSON.parse(localStorage.getItem('wishlist_products')) || [];
      } catch(e) {
        items = [];
      }
      window.dispatchEvent(new Event('wishlist-updated'));

      loadingEl.classList.add('hidden');

      if (items.length === 0) {
        emptyEl.classList.remove('hidden');
        gridEl.classList.add('hidden');
        return;
      }

      emptyEl.classList.add('hidden');
      gridEl.classList.remove('hidden');
      gridEl.innerHTML = '';

      items.forEach((item, index) => {
        const card = document.createElement('div');
        card.className = 'wishlist-card';
        card.innerHTML = `
          <div class="wishlist-card__image-wrapper">
            <button class="wishlist-remove-btn" data-index="${index}" aria-label="Remove from wishlist">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
            <a href="${item.url}">
              <img src="${item.image || '//cdn.shopify.com/s/files/1/0000/0000/assets/no-image.gif'}" alt="${item.title}" class="wishlist-card__image" loading="lazy">
            </a>
          </div>
          <div class="wishlist-card__info">
            <h3 class="wishlist-card__title">
              <a href="${item.url}">${item.title}</a>
            </h3>
            <div class="wishlist-card__price">${item.price}</div>
            <div class="wishlist-card__actions">
              <button class="wishlist-card__add-btn" data-variant-id="${item.variantId}">Add to Cart</button>
            </div>
          </div>
        `;
        gridEl.appendChild(card);
      });

      // Bind Remove Clicks
      gridEl.querySelectorAll('.wishlist-remove-btn').forEach(btn => {
        btn.addEventListener('click', function() {
          const index = parseInt(this.getAttribute('data-index'));
          items.splice(index, 1);
          localStorage.setItem('wishlist_products', JSON.stringify(items));
          window.dispatchEvent(new Event('wishlist-updated'));
          loadWishlist();
          showToast('Removed from wishlist successfully.');
        });
      });

      // Bind Add to Cart Clicks
      gridEl.querySelectorAll('.wishlist-card__add-btn').forEach(btn => {
        btn.addEventListener('click', function() {
          const variantId = this.getAttribute('data-variant-id');
          if (!variantId) {
            showToast('Unable to add to cart: variant not found.');
            return;
          }

          // Disable button during action
          this.disabled = true;
          this.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(res => {
            if (!res.ok) throw new Error('Network response not ok');
            return res.json();
          })
          .then(data => {
            showToast('✓ Successfully added to cart!');
            this.textContent = 'Added';
            
            // Trigger header count update
            fetch('/cart.js')
              .then(res => res.json())
              .then(cartData => {
                let countBadge = document.getElementById('CartCountBadge') || document.querySelector('.cart-badge');
                if (!countBadge) {
                  const wrap = document.getElementById('cart-icon-wrap');
                  if (wrap) {
                    countBadge = document.createElement('span');
                    countBadge.className = 'cart-badge';
                    countBadge.id = 'CartCountBadge';
                    wrap.appendChild(countBadge);
                  }
                }
                if (countBadge) {
                  countBadge.textContent = cartData.item_count;
                  countBadge.style.display = cartData.item_count > 0 ? 'flex' : 'none';
                }
              });
          })
          .catch(err => {
            console.error('Error adding to cart:', err);
            showToast('Error adding to cart. Please try again.');
            this.disabled = false;
            this.textContent = 'Add to Cart';
          });
        });
      });
    }

    loadWishlist();
  });

  } catch(e) { console.error(e); }
})();
})();
